export abstract class StartupService {
    abstract initializeNavService(): void;
}
